module.exports = __webpack_public_path__ + "imgcvh/hero-3.751e0928.jpg";